import Image from 'next/image';

/**
 * Match `ResourceCardImageInner` on the customer stories index: the inner image
 * is taller than the visible frame so `overflow: hidden` on the parent shows
 * the top band (brand logo focus). See customer-stories index for context.
 */
export const CUSTOMER_STORY_CARD_COVER_VERTICAL_FOCUS_MULTIPLIER = 2.45;

export type PostThumbCroppedProps = {
  category?: string;
  title?: string;
  theme?: 'light' | 'dark' | 'white';
  imageSrc?: string;
  href?: string;
  onAssetClick?: (videoId: string) => void;
};

export const PostThumbCropped = ({
  category,
  title,
  theme,
  imageSrc = 'https://front.com/webassets/rebrand/promo-banner.webp',
  href = '#',
  onAssetClick,
}: PostThumbCroppedProps) => {
  const categoryClass = {
    light: 'text-gray-600',
    dark: 'text-citron-500',
    white: 'text-gray-600',
  }[theme || 'light'];

  const titleClass = {
    light: 'text-blue-900',
    dark: 'text-white',
    white: 'text-blue-900',
  }[theme || 'light'];

  const innerImageHeightPercent =
    CUSTOMER_STORY_CARD_COVER_VERTICAL_FOCUS_MULTIPLIER * 100;

  return (
    <a href={href} className="group flex flex-col gap-3">
      <div className="relative h-[270px] overflow-hidden rounded-[10px] bg-gray-100">
        {imageSrc && (
          <div
            className="absolute left-0 right-0 top-0 w-full"
            style={{ height: `${innerImageHeightPercent}%` }}
          >
            <Image
              src={imageSrc}
              alt=""
              fill
              className="object-cover object-top"
              onClick={() => onAssetClick?.(imageSrc ?? '')}
            />
          </div>
        )}
      </div>
      <div className="flex flex-col gap-[12px]">
        {category && (
          <span
            className={`${categoryClass} text-micro2 uppercase md:text-caption1`}
          >
            {category}
          </span>
        )}
        {title && (
          <div className={`${titleClass} block text-h4 font-500`}>
            <span className="link-animated-underline">{title}</span>
          </div>
        )}
      </div>
    </a>
  );
};
